module.exports = __webpack_public_path__ + "static/media/tb-picture-2.737cc949.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TeamBuilding/tb-picture-2.png
// module id = 613
// module chunks = 0